module.exports = __webpack_public_path__ + "/login_ui/img/ci-d14b72eb69124c08992f0874cbc36420.svg";